import { useState, useEffect } from "react";
import ProjectsCard from "./ProjectsCard";
import { projects } from "../../data/projectsData";

function Projects() {
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const displayLimit = isMobile ? 3 : 4;
  const displayedProjects = showAll
    ? projects
    : projects.slice(0, displayLimit);
  const hasMore = projects.length > displayLimit;

  return (
    <section
      id="projects"
      className="py-20 px-6 md:px-12 lg:px-20 bg-hero-background border-l-4 border-blue-600"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-blue-600 mb-12">
          Projects
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {displayedProjects.map((project, index) => (
            <ProjectsCard key={index} project={project} index={index} />
          ))}
        </div>
        {hasMore && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
            >
              {showAll ? "Show Less" : "Show More Projects"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default Projects;
